import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { surveyApi } from '../../../api/surveyApi';
import { getDaybyDate, isSuperAndSubAdmin } from '../../../utils/helper';
import DonutChartCard from '../../../component/common/cards/DonutChartCard';
import DonutChartCardDropdown from '../../../component/common/cards/DonutChartCardDropdown';
import moment from 'moment';
import { pulseSurveyPageData } from '../../../utils/pageContent';

const options2 = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false
      }
    },
    y: {
      grid: {
        drawOnChartArea: false
      },
      ticks: {
        beginAtZero: true,
        stepSize: 100,
        callback: function (value) {
          return value % 100 === 0 ? value : '';
        }
      }
    }
  }
};

const ProgressBar = ({ label, percentage }) => (
  <div className="mb-4">
    {!!label && (
      <div className="flex justify-between items-center mb-1">
        <span className="text-lg font-normal">{label}</span>
        <span className="text-sm text-green-600">{percentage}%</span>
      </div>
    )}
    <div className="w-full bg-[#C2EC97] rounded-full h-2 flex items-center">
      <div
        className="bg-[#67A14A] h-2.5 rounded-full"
        style={{ width: `${percentage}%`, height: '133%' }}
      ></div>
    </div>
  </div>
);

const InsightsB2B = ({ InsightsData, userAgeRangeData }) => {
  const pageData = pulseSurveyPageData.insightsB2BPageData;
  const dataG = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: pageData.surveyMonthlyAnalysisText,
        data: [2, 9, 8, 2, 6, 7],
        backgroundColor: '#4A57DA',
        borderColor: '#4A57DA',
        borderRadius: 3,
        borderWidth: 1
      }
    ]
  };

  const dataForCompletedSurveys = [
    {
      label: pageData.completedText,
      value: 100,
      percentage: 50,
      color: '#D97F56'
    },
    {
      label: pageData.incompleteText,
      value: 60,
      percentage: 30,
      color: '#ECC09E'
    },
    {
      label: pageData.introText,
      value: 40,
      percentage: 20,
      color: '#ECC09E'
    }
  ];

  const dataForUserAgeRange = [
    {
      label: pageData.userAgeRange.age18To25,
      value: 90,
      percentage: 60,
      color: '#228B22'
    },
    {
      label: pageData.userAgeRange.age26To32,
      value: 45,
      percentage: 30,
      color: '#67A14A'
    },
    {
      label: pageData.userAgeRange.age32To40,
      value: 9,
      percentage: 6,
      color: '#C2EC97'
    },
    {
      label: pageData.userAgeRange.ageAbove40,
      value: 6,
      percentage: 4,
      color: '#2E8B57'
    }
  ];

  const dataForGenderOutcome = [
    {
      label: pageData.gender.male,
      value: 10,
      percentage: 40,
      color: '#F05289'
    },
    {
      label: pageData.gender.female,
      value: 15,
      percentage: 60,
      color: '#FF9BCB'
    }
  ];

  const dataForTopUsage = [
    {
      label: pageData.topUsagesTimes.label1,
      value: 3,
      percentage: 10,
      color: '#21BDAD'
    },
    {
      label: pageData.topUsagesTimes.label2,
      value: 9,
      percentage: 30,
      color: '#6BE0BD'
    },
    {
      label: pageData.topUsagesTimes.label3,
      value: 12,
      percentage: 40,
      color: '#00ffff'
    },
    {
      label: pageData.topUsagesTimes.label4,
      value: 6,
      percentage: 20,
      color: '#00cccc'
    }
  ];

  const dataForDepartmentOutcome = [
    {
      label: pageData.departmentOutcomeData.marketing,
      value: 1,
      percentage: 10,
      color: '#EDCC12'
    },
    {
      label: pageData.departmentOutcomeData.fianance,
      value: 3,
      percentage: 30,
      color: '#FFE873'
    },
    {
      label: pageData.departmentOutcomeData.it,
      value: 4,
      percentage: 40,
      color: '#E3B778'
    },
    {
      label: pageData.departmentOutcomeData.hr,
      value: 2,
      percentage: 20,
      color: '#F9E076'
    }
  ];

  const dataD = InsightsData?.weeklyUserCount && {
    labels: InsightsData?.weeklyUserCount
      ? InsightsData?.weeklyUserCount.map((item) => getDaybyDate(item.date))
      : [],
    datasets: [
      {
        label: pageData.weeklyUsageText,
        data: InsightsData?.weeklyUserCount.map((item) => item.count),
        backgroundColor: 'rgba(74, 87, 218, 1)',
        borderColor: 'rgba(74, 87, 218, 1)',
        borderRadius: 3,
        borderWidth: 1
      }
    ]
  };

  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: pageData.surveyMonthlyAnalysisText,
        data: [0, 0, 0, 0, 0, 0],
        backgroundColor: '#3a47ab',
        borderColor: ' #4a56db',
        borderRadius: 3,
        borderWidth: 1
      }
    ]
  };

  const CompletedAssigsmentData = [
    {
      label: pageData.completeText,
      value: InsightsData?.completionRate
        ? InsightsData?.completionRate == 'NaN'
          ? 0
          : Number(InsightsData?.completionRate)
        : 0,
      percentage: InsightsData?.completionRate
        ? InsightsData?.completionRate == 'NaN'
          ? 0
          : Number(InsightsData?.completionRate)
        : 0,
      color: '#D97F56'
    },
    {
      label: pageData.notCompletedText,
      value: InsightsData?.percentageIncomplete
        ? InsightsData?.percentageIncomplete == 'NaN'
          ? 0
          : Number(InsightsData?.percentageIncomplete)
        : 0,
      percentage: InsightsData?.percentageIncomplete
        ? InsightsData?.percentageIncomplete == 'NaN'
          ? 0
          : Number(InsightsData?.percentageIncomplete)
        : 0,
      color: '#D97F56'
    }
  ];

  const AgeRangeData = [
    {
      label: pageData.ageRangeDataLabels.age18To25,
      value: userAgeRangeData?.[0]?.percentage
        ? userAgeRangeData?.[0]?.percentage == 'NaN'
          ? 0
          : Number(userAgeRangeData?.[0]?.percentage)
        : 0,
      percentage: userAgeRangeData?.[0]?.percentage
        ? userAgeRangeData?.[0]?.percentage == 'NaN'
          ? 0
          : Number(userAgeRangeData?.[0]?.percentage)
        : 0,
      color: '#67A14A'
    },
    {
      label: pageData.ageRangeDataLabels.age26To32,
      value: userAgeRangeData?.[0]?.percentage
        ? userAgeRangeData?.[0]?.percentage == 'NaN'
          ? 0
          : Number(userAgeRangeData?.[0]?.percentage)
        : 0,
      percentage: userAgeRangeData?.[0]?.percentage
        ? userAgeRangeData?.[0]?.percentage == 'NaN'
          ? 0
          : Number(userAgeRangeData?.[0]?.percentage)
        : 0,
      color: '#C2EC97'
    }
  ];

  const CommonOutComeData = [
    {
      label: pageData.commonOutComeDataLabels.anxiety,
      value: 0,
      percentage: 0,
      color: '#F05289'
    },
    {
      label: pageData.commonOutComeDataLabels.depression,
      value: 0,
      percentage: 0,
      color: '#FF9BCB'
    }
  ];

  const TopTimeUseData = [
    {
      label: pageData.topTimeUseDataLabels.nineToTen,
      value: 0,
      percentage: 0,
      color: '#21BDAD'
    },
    {
      label: pageData.topTimeUseDataLabels.sevenToEight,
      value: 0,
      percentage: 0,
      color: '#6BE0BD'
    }
  ];

  const AvrageScoreData = [
    {
      label: pageData.averageScoreDataLabels.label1,
      value: InsightsData?.attemptRangeDistribution?.[0]?.percentage
        ? InsightsData?.attemptRangeDistribution?.[0]?.percentage == 'NaN'
          ? 0
          : Number(InsightsData?.attemptRangeDistribution?.[0]?.percentage)
        : 0,
      percentage: InsightsData?.attemptRangeDistribution?.[0]?.percentage
        ? InsightsData?.attemptRangeDistribution?.[0]?.percentage == 'NaN'
          ? 0
          : Number(InsightsData?.attemptRangeDistribution?.[0]?.percentage)
        : 0,
      color: '#EDCC12'
    },
    {
      label: pageData.averageScoreDataLabels.label2,
      value: InsightsData?.attemptRangeDistribution?.[1]?.percentage
        ? InsightsData?.attemptRangeDistribution?.[1]?.percentage
          ? 0
          : Number(InsightsData?.attemptRangeDistribution?.[1]?.percentage)
        : 0,
      percentage: InsightsData?.attemptRangeDistribution?.[1]?.percentage
        ? InsightsData?.attemptRangeDistribution?.[1]?.percentage == 'NaN'
          ? 0
          : Number(InsightsData?.attemptRangeDistribution?.[1]?.percentage)
        : 0,
      color: '#FFE873'
    }
  ];

  const insightList = [
    {
      component: (
        <DonutChartCard data={CompletedAssigsmentData} hidePercentage title={pageData.completedSurveysLabel} />
      )
    },
    {
      component: <DonutChartCard data={AgeRangeData} hidePercentage title={pageData.userAgeRangeTitle} />
    },
    {
      component: <DonutChartCard data={CommonOutComeData} hidePercentage title={pageData.commonOutComeTitle} />
    },
    {
      component: <DonutChartCard data={TopTimeUseData} hidePercentage title={pageData.topUsageTimesTitle} />
    },
    {
      component: <DonutChartCard data={AvrageScoreData} hidePercentage title={pageData.averageScoreTitle} />
    }
  ];
  const resultData = {};

  return (
    <div className="w-full mb-10 font-work-sans">
      <div className="flex sm:flex-row flex-col h-auto gap-4 my-5">
        <div className="w-full sm:w-3/12 md:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] border-[#E7E8EA] flex items-center p-5 dark:bg-shoorah-darkBgTabColor dark:border-none">
          <div className="flex flex-row items-center w-full">
            <div className="flex justify-center items-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#4A57DA" />
                <path
                  d="M33.98 26.79V30.79C33.98 31.05 33.97 31.3 33.94 31.54C33.71 34.24 32.12 35.58 29.19 35.58H28.79C28.54 35.58 28.3 35.7 28.15 35.9L26.95 37.5C26.42 38.21 25.56 38.21 25.03 37.5L23.83 35.9C23.7 35.73 23.41 35.58 23.19 35.58H22.79C19.6 35.58 18 34.79 18 30.79V26.79C18 23.86 19.35 22.27 22.04 22.04C22.28 22.01 22.53 22 22.79 22H29.19C32.38 22 33.98 23.6 33.98 26.79Z"
                  stroke="white"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M37.98 22.79V26.79C37.98 29.73 36.63 31.31 33.94 31.54C33.97 31.3 33.98 31.05 33.98 30.79V26.79C33.98 23.6 32.38 22 29.19 22H22.79C22.53 22 22.28 22.01 22.04 22.04C22.27 19.35 23.86 18 26.79 18H33.19C36.38 18 37.98 19.6 37.98 22.79Z"
                  stroke="white"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M29.4955 29.25H29.5045"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M25.9955 29.25H26.0045"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.4955 29.25H22.5045"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex flex-col text-start ml-4">
              <p className="text-[14px] tracking-tight">{pageData.totalResponseText}</p>
              <p className="text-[24px] font-medium">
                {InsightsData?.totalResponses ? InsightsData?.totalResponses : 0}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-3/12 md:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] flex items-center pl-3 border-[#E7E8EA] dark:bg-shoorah-darkBgTabColor dark:border-none">
          <div className="flex flex-row items-center w-full">
            <div className="flex justify-center items-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#F05289" />
                <path
                  d="M34.32 28.0002C36.92 28.0002 38 27.0002 37.04 23.7202C36.39 21.5102 34.49 19.6102 32.28 18.9602C29 18.0002 28 19.0802 28 21.6802V24.5602C28 27.0002 29 28.0002 31 28.0002H34.32Z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M36.0004 30.6998C35.0704 35.3298 30.6304 38.6898 25.5804 37.8698C21.7904 37.2598 18.7404 34.2098 18.1204 30.4198C17.3104 25.3898 20.6504 20.9498 25.2604 20.0098"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className=" flex flex-col text-start ml-4">
              <p className="text-[14px] tracking-tight">{pageData.completionRateText}</p>
              <p className="text-[24px] font-medium">
                {InsightsData?.completionRate ? Number(InsightsData.completionRate) : 0}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-3/12 md:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] flex items-center pl-3 border-[#E7E8EA] dark:bg-shoorah-darkBgTabColor dark:border-none">
          <div className="flex flex-row items-center w-full">
            <div className="flex justify-center items-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#0B1D2E" />
                <path
                  d="M36.75 29.25C36.75 34.08 32.83 38 28 38C23.17 38 19.25 34.08 19.25 29.25C19.25 24.42 23.17 20.5 28 20.5C32.83 20.5 36.75 24.42 36.75 29.25Z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28 24V29"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M25 18H31"
                  stroke="white"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex flex-col text-start ml-4">
              <p className="text-[14px] tracking-tight">{pageData.userRangeText}</p>
              <p className="text-[24px] font-medium">
                {InsightsData?.userRange ? Number(InsightsData.userRange) : 0}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-3/12 md:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] flex items-center pl-3 border-[#E7E8EA] dark:bg-shoorah-darkBgTabColor dark:border-none">
          <div className="flex flex-row items-center w-full">
            <div className="flex justify-center items-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#20BDAD" />
                <path
                  d="M33 34.4297H29L24.55 37.3897C23.89 37.8297 23 37.3598 23 36.5598V34.4297C20 34.4297 18 32.4297 18 29.4297V23.4297C18 20.4297 20 18.4297 23 18.4297H33C36 18.4297 38 20.4297 38 23.4297V29.4297C38 32.4297 36 34.4297 33 34.4297Z"
                  stroke="white"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M27.9998 27.3604V27.1504C27.9998 26.4704 28.4198 26.1104 28.8398 25.8204C29.2498 25.5404 29.6598 25.1804 29.6598 24.5204C29.6598 23.6004 28.9198 22.8604 27.9998 22.8604C27.0798 22.8604 26.3398 23.6004 26.3398 24.5204"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M27.9955 29.75H28.0045"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex flex-col text-start ml-4">
              <p className="text-[14px] tracking-tight">{pageData.skippedOptionsText}</p>
              <p className="text-[24px] font-medium">
                {InsightsData?.skippedQuestions ? InsightsData?.skippedQuestions : 0}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row md:flex-col gap-7 w-full overflow-x-auto horizontal-card-scrollbar pb-2">
        <div className="w-full h-[333px] lg:max-w-[225px] 2xl:max-w-[295px]">
          <DonutChartCardDropdown
            data={dataForCompletedSurveys}
            title={pageData.completedSurveysLabel}
            labelClassName={'w-full'}
            centerText={pageData.completedText}
            className={
              'dark:!bg-shoorah-darkBgTabColor dark:!border-none flex flex-col justify-between lg:w-full h-full'
            }
          />
        </div>
        <div className="w-full h-[333px] lg:max-w-[225px] 2xl:max-w-[295px]">
          <DonutChartCardDropdown
            data={dataForUserAgeRange}
            title={pageData.userAgeRangeTitle}
            labelClassName={'w-full'}
            centerText={pageData.maxAgeRangeText}
            className={
              'dark:!bg-shoorah-darkBgTabColor dark:!border-none flex flex-col justify-between lg:w-full h-full'
            }
          />
        </div>
        <div className="w-full h-[333px] lg:max-w-[225px] 2xl:max-w-[295px]">
          <DonutChartCardDropdown
            data={dataForGenderOutcome}
            title={pageData.genderOutComeText}
            labelClassName={'w-full'}
            centerText={pageData.genderText}
            className={
              'dark:!bg-shoorah-darkBgTabColor dark:!border-none flex flex-col justify-between lg:w-full h-full'
            }
          />
        </div>
        <div className="w-full h-[333px] lg:max-w-[225px] 2xl:max-w-[295px]">
          <DonutChartCardDropdown
            data={dataForTopUsage}
            title={pageData.topUsageTimesTitle}
            labelClassName={'w-full'}
            centerText={pageData.maxTimeText}
            className={
              'dark:!bg-shoorah-darkBgTabColor dark:!border-none flex flex-col justify-between lg:w-full h-full'
            }
          />
        </div>
        <div className="w-full h-[333px] lg:max-w-[225px] 2xl:max-w-[285px]">
          <DonutChartCardDropdown
            data={dataForDepartmentOutcome}
            title={pageData.departmentOutComeText}
            labelClassName={'w-full'}
            centerText={pageData.maxDepartmentText}
            className={
              'dark:!bg-shoorah-darkBgTabColor dark:!border-none flex flex-col justify-between lg:w-full h-full'
            }
          />
        </div>
        {/* <div className="md:flex md:flex-row sm:gap-[31px] 2xl:gap-10 w-full">
          {insightList.map((value, key) => (
            <React.Fragment key={key}>{value.component}</React.Fragment>
          ))}
        </div> */}
      </div>

      <div className="flex flex-col lg:flex-row md:flex-col gap-5 sm:w-full lg:mb-2 overflow-x-auto horizontal-card-scrollbar overflow-y-hidden">
        <div className="flex flex-col justify-between w-full md:w-full lg:min-w-[235px] lg:max-w-[265px] 2xl:max-w-[300px] h-[200px] md:h-[200px] lg:h-[344px] bg-white rounded-xl border-[1.5px] border-shoorah-borderGray p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
          <p className="text-[20px] lg:text-[20px] md:text-[25px] leading-tight h-[66px]  font-medium  w-[80%] justify-start text-shoorah-lightBlack dark:text-shoorah-darkBg">
            {pageData.percentageOfIncompleteAssessmentText}
          </p>
          <p className="lg:text-[48px] text-[36px] text-shoorah-lightBlack font-medium dark:text-shoorah-darkBg">
            {resultData?.incompletePercentage ? resultData?.incompletePercentage : '35'} %
          </p>
        </div>

        <div className=" flex flex-col justify-between w-full md:w-full lg:min-w-[235px] lg:max-w-[405px] 3xl:min-w-[420px] h-[300px] lg:h-[344px] bg-white rounded-xl border-[1.5px] border-shoorah-borderGray p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
          <p className="text-[20px] lg:text-[20px] md:text-[25px] leading-tight h-[66px]  font-medium  w-[100%] justify-start text-shoorah-lightBlack dark:text-shoorah-darkBg">
            {pageData.dropOffPointText}
          </p>

          <div className=" md:py-2 py-1.5 bg-[#ffffff]  dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className="flex items-center justify-between mb-[10px]">
              <div className="text-base font-medium leading-[22px] text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {pageData.introText}
              </div>
              <div className="text-xs leading-[100%] font-medium text-[#67A14A]">
                {resultData?.completionRate || 7} %
              </div>
            </div>
            <div>
              <ProgressBar percentage={resultData?.completionRate?.split('%')[0] || 7} />
            </div>
          </div>

          <div className=" md:py-2 py-1.5 bg-[#ffffff]  dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className="flex items-center justify-between mb-[10px]">
              <div className="text-base font-medium leading-[22px] text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {pageData.incompleteText}
              </div>
              <div className="text-xs leading-[100%] font-medium text-[#67A14A]">
                {resultData?.completionRate || 55} %
              </div>
            </div>
            <div>
              <ProgressBar percentage={resultData?.completionRate?.split('%')[0] || 55} />
            </div>
          </div>

          <div className=" md:py-2 py-1.5 bg-[#ffffff]  dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className="flex items-center justify-between mb-[10px]">
              <div className="text-base font-medium leading-[22px] text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {pageData.completedText}
              </div>
              <div className="text-xs leading-[100%] font-medium text-[#67A14A]">
                {resultData?.completionRate || 89} %
              </div>
            </div>
            <div>
              <ProgressBar percentage={resultData?.completionRate?.split('%')[0] || 89} />
            </div>
          </div>
        </div>

        <div className="h-[344px] max-w-[564px] w-full bg-white rounded-xl border-[1.5px] border-shoorah-borderGray p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
          <div className="flex justify-between w-full items-center mb-1">
            <p className="text-[20px] lg:text-[20px] md:text-[25px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {pageData.weeklyUsageText}
            </p>
            <p className="text-[20px] lg:text-[20px] md:text-[25px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {resultData?.totalWeeklyUsers || 456} {pageData.usersText}
            </p>
          </div>
          <div className="flex justify-between w-full items-center mb-[18px]">
            <p className="text-[14px] leading-5 text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {moment(resultData?.weeklyUserCounts?.[0]?.date)?.format('Do')} -{' '}
              {moment(
                resultData?.weeklyUserCounts?.[resultData?.weeklyUserCounts?.length - 1]?.date
              )?.format('Do MMM, YYYY')}
            </p>
            <p className="text-[16px] font-medium leading-6 text-[#28D9A0] flex flex-row items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.9075 10C11.0899 10 11.2868 9.92565 11.3225 9.73992C11.3544 9.57417 11.3113 9.39471 11.1932 9.26602L8.33607 6.15201C8.1501 5.94933 7.8486 5.94933 7.66263 6.15201L4.80549 9.26602C4.68741 9.39471 4.64431 9.57417 4.67617 9.73992C4.71187 9.92565 4.90875 10 5.0912 10L10.9075 10Z"
                  fill="#61CD82"
                />
              </svg>
              {data?.will_come_soon || +235.21} %
            </p>
          </div>
          <Bar
            data={dataG || data}
            options={{
              ...options2
            }}
            className="!h-[222px]"
          />
        </div>
      </div>

    </div>
  );
};

export default InsightsB2B;
